import { useCallback, useEffect, useRef, useState } from 'react';

/** 파싱 대기 중 다시 읽는 간격과 상한. */
export const PARSE_POLL_INTERVAL_MS = 10 * 1000;
export const PARSE_POLL_MAX_MS = 10 * 60 * 1000;

/**
 * 제한된 시간 동안만 주기적으로 묻는다. 결과 알림이 유실됐을 때의 보완책이라 상한이 지나면 멈추고 exhausted로 알린다.
 * resetKey가 바뀌면(새 문서·새 연결·새 알림) 처음부터 다시 센다.
 */
export default function useLimitedInterval({ enabled, intervalMs = PARSE_POLL_INTERVAL_MS, maxMs = PARSE_POLL_MAX_MS, resetKey, onTick }) {
    const [round, setRound] = useState(0);
    const [exhausted, setExhausted] = useState(false);
    const tickRef = useRef(onTick);
    tickRef.current = onTick;

    useEffect(() => {
        setExhausted(false);
        if (!enabled) return undefined;
        const startedAt = Date.now();
        const timer = setInterval(() => {
            if (Date.now() - startedAt >= maxMs) {
                clearInterval(timer);
                setExhausted(true);
                return;
            }
            tickRef.current?.();
        }, intervalMs);
        return () => clearInterval(timer);
    }, [enabled, intervalMs, maxMs, resetKey, round]);

    /** 담당자가 Check again을 누르면 바로 한 번 묻고 다시 센다. */
    const restart = useCallback(() => {
        tickRef.current?.();
        setRound((r) => r + 1);
    }, []);

    return { exhausted, restart };
}
